import { render, staticRenderFns } from "./QuantumSafeDemo.vue?vue&type=template&id=5b4802f1&scoped=true"
import script from "./QuantumSafeDemo.vue?vue&type=script&lang=js"
export * from "./QuantumSafeDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4802f1",
  null
  
)

export default component.exports